import React, { Component } from 'react';
import { Tag, Popover, Badge, Table, Button, Empty, List } from 'antd';
import groupBy from 'lodash/groupBy';
import moment from 'moment';
import { connect } from 'react-redux';
import {
	markAllUserNotificationsReadForBuyer,
	markAllUserNotificationsReadForSupplier,
	userNotificationsRestCrudThunksForBuyer,
	userNotificationsRestCrudThunksForSupplier,
} from '../../thunks/user_notifications_thunks';
import { nullSafeGet } from '../../utils/DataAccessUtils';
import { ROLE_TYPES } from '../../utils/DataConstants';
import { withRouter } from 'react-router';
import { getRecordsForTargetCollection } from '../../reducers/standard_reducer_utils';
import UserNotificationRowDisplay from '../user_notification_row_display/UserNotificationRowDisplay';
import UserNotificationsRowSlimDisplay from '../user_notification_row_display/UserNotificationsRowSlimDisplay';

const READ_NOTIFICATIONS = 'READ_NOTIFICATIONS';
const UNREAD_NOTIFICATIONS = 'UNREAD_NOTIFICATIONS';

const style = require('./UserNotificationsDropdown.less');

class UserNotificationsDropdown extends Component<any, any> {
	componentDidMount() {
		const {
			fetchUserNotificationsForBuyer,
			fetchUserNotificationsForSupplier,
			fetchUserNotificationsCountForBuyer,
			fetchUserNotificationsCountForSupplier,
			userType,
		} = this.props;
		const fetchUserNotifications =
			userType === ROLE_TYPES.BUYER
				? fetchUserNotificationsForBuyer
				: fetchUserNotificationsForSupplier;
		const fetchUserNotificationsCount =
			userType === ROLE_TYPES.BUYER
				? fetchUserNotificationsCountForBuyer
				: fetchUserNotificationsCountForSupplier;

		fetchUserNotifications(
			{ hasSeen: false },
			'UNREAD_NOTIFICATIONS',
			{
				current: 1,
				pageSize: 5,
			},
			{ sort_by: 'createdAt', order: 'desc' }
		);
		fetchUserNotificationsCount({ hasSeen: false }, 'UNREAD_NOTIFICATIONS');
	}

	changeReadState = () => {};

	handleNoticeClear = () => {};

	getNoticeData = () => {
		const { notices = [] } = this.props;
		if (notices.length === 0) {
			return {};
		}
		const newNotices = notices.map((notice) => {
			const newNotice = { ...notice };
			if (newNotice.datetime) {
				newNotice.datetime = moment(notice.datetime as string).fromNow();
			}
			if (newNotice.id) {
				newNotice.key = newNotice.id;
			}
			if (newNotice.extra && newNotice.status) {
				const color = {
					todo: '',
					processing: 'blue',
					urgent: 'red',
					doing: 'gold',
				}[newNotice.status];
				newNotice.extra = (
					<Tag color={color} style={{ marginRight: 0 }}>
						{newNotice.extra}
					</Tag>
				);
			}
			return newNotice;
		});
		return groupBy(newNotices, 'type');
	};

	getUnreadData = (noticeData) => {
		const unreadMsg = {};
		Object.keys(noticeData).forEach((key) => {
			const value = noticeData[key];
			if (!unreadMsg[key]) {
				unreadMsg[key] = 0;
			}
			if (Array.isArray(value)) {
				unreadMsg[key] = value.filter((item) => !item.read).length;
			}
		});
		return unreadMsg;
	};

	refetchNotificationData = () => {
		const {
			fetchUserNotificationsForBuyer,
			fetchUserNotificationsForSupplier,
			fetchUserNotificationsCountForBuyer,
			fetchUserNotificationsCountForSupplier,
			userType,
		} = this.props;
		const fetchUserNotifications =
			userType === ROLE_TYPES.BUYER
				? fetchUserNotificationsForBuyer
				: fetchUserNotificationsForSupplier;
		const fetchUserNotificationsCount =
			userType === ROLE_TYPES.BUYER
				? fetchUserNotificationsCountForBuyer
				: fetchUserNotificationsCountForSupplier;

		fetchUserNotifications(
			{ hasSeen: false },
			'UNREAD_NOTIFICATIONS',
			{
				current: 1,
				pageSize: 5,
			},
			{ sort_by: 'createdAt', order: 'desc' }
		);
		fetchUserNotificationsCount({ hasSeen: false }, 'UNREAD_NOTIFICATIONS');
	};

	handleMarkAllRead = () => {
		const { userType, userNotifications, markAllReadForBuyer, markAllReadForSupplier } = this.props;
		const unreadNotifications = getRecordsForTargetCollection(
			userNotifications,
			UNREAD_NOTIFICATIONS
		);
		const markAllRead =
			userType === ROLE_TYPES.BUYER ? markAllReadForBuyer : markAllReadForSupplier;
		if (unreadNotifications && unreadNotifications.length > 0) {
			const latestUnreadNotification = unreadNotifications[0];
			markAllRead(latestUnreadNotification).then(() => {
				this.refetchNotificationData();
			});
		}
	};

	render() {
		const { userType, userNotifications, history } = this.props;
		const notificationsFetching = userNotifications.fetching;
		const unreadNotifications = getRecordsForTargetCollection(
			userNotifications,
			UNREAD_NOTIFICATIONS
		);
		const readNotifications = getRecordsForTargetCollection(userNotifications, READ_NOTIFICATIONS);
		const formatNotifications = (notifications) =>
			notifications.map((notification) => ({
				...notification,
				title: nullSafeGet(`${userType}PushNotification.webAppMessage`, notification),
				datetime: notification.createdAt,
				contact: notification.userContact,
			}));
		const formattedUnreadNotifications = formatNotifications(unreadNotifications);
		const unreadCount = userNotifications.counts[UNREAD_NOTIFICATIONS];

		return (
			<Popover
				trigger="click"
				placement="topRight"
				overlayStyle={{ width: 400, maxHeight: 668, overflow: 'hidden' }}
				title={
					<div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
						<div style={{ fontSize: 14, fontWeight: 500 }}>Unread Notifications</div>
						<Button onClick={this.handleMarkAllRead} type="link">
							Mark all read
						</Button>
					</div>
				}
				content={
					<div style={{ marginTop: -12, marginLeft: -16, marginRight: -16 }}>
						<div style={{ maxHeight: 560, overflowY: 'scroll' }}>
							{unreadCount === 0 ? (
								<Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="No unread notifications" />
							) : null}
							{unreadCount > 0 ? (
								<List
									loading={notificationsFetching}
									itemLayout="horizontal"
									dataSource={formattedUnreadNotifications}
									renderItem={(item, index) => (
										<UserNotificationsRowSlimDisplay notification={item} userType={userType} />
									)}
								/>
							) : null}
						</div>
						<div
							style={{
								borderBottomLeftRadius: 4,
								borderBottomRightRadius: 4,
								padding: '4px 0',
								marginBottom: -12,
								border: '1px solid #e8e8e8',
								textAlign: 'center',
							}}
						>
							<Button
								onClick={() => history.push(`/${userType}/notifications/overview/all`)}
								type="link"
							>
								See all
							</Button>
						</div>
					</div>
				}
			>
				<Badge count={unreadCount}>
					<i
						style={{ fontSize: 20, color: 'rgba(255, 255, 255, 0.9)' }}
						className="icons8-font icons8-notification-filled"
					/>
				</Badge>
			</Popover>
		);
	}
}

const mapStateToProps = (state, ownProps) => ({
	history: ownProps.history,
	userNotifications: state.user_notifications,
});

const mapDispatchToProps = (dispatch) => ({
	fetchUserNotificationsForBuyer: (
		params,
		targetCollectionName = null,
		pagination = null,
		sorting = null,
		filters = null,
		addToTargetCollection = false
	) =>
		dispatch(
			userNotificationsRestCrudThunksForBuyer.read(
				params,
				targetCollectionName,
				pagination,
				sorting,
				filters,
				addToTargetCollection
			)
		),
	fetchUserNotificationsCountForBuyer: (params, countName = null) =>
		dispatch(userNotificationsRestCrudThunksForBuyer.countBy(params, countName)),
	fetchUserNotificationsForSupplier: (
		params,
		targetCollectionName = null,
		pagination = null,
		sorting = null,
		filters = null,
		addToTargetCollection = false
	) =>
		dispatch(
			userNotificationsRestCrudThunksForSupplier.read(
				params,
				targetCollectionName,
				pagination,
				sorting,
				filters,
				addToTargetCollection
			)
		),
	fetchUserNotificationsCountForSupplier: (params, countName = null) =>
		dispatch(userNotificationsRestCrudThunksForSupplier.countBy(params, countName)),
	markAllReadForBuyer: (entity) => dispatch(markAllUserNotificationsReadForBuyer(entity)),
	markAllReadForSupplier: (entity) => dispatch(markAllUserNotificationsReadForSupplier(entity)),
});

export default withRouter<any, any>(
	connect(mapStateToProps, mapDispatchToProps)(UserNotificationsDropdown)
);
